//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */

// ReSharper disable InconsistentNaming

export interface Address {
  line1: string;
  line2: string | null;
  line3: string | null;
  line4: string | null;
  locality: string | null;
  region: string | null;
  postcode: string;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  source: string | null;
}

export interface ApiToken {
  origin: TokenOrigin;
  dateIssued: string;
  dateExpires: string;
  version: number;
  type: UserType;
  tenantId: number;
  dealerDeploymentId: number;
  systemUserId: string;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  jobTitle: string;
  phone: string;
  services: Services;
  claims: { [key: string]: string };
}

export interface BaseLogin {
  dateCreated: string;
  id: number;
  recordVersion: string;
  systemUserId: string;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  phoneNumber: string;
  jobTitle: string;
  claims: { [key: string]: string };
}

export interface CynclyLoginFilter {
  dateCreated: string;
  id: number;
  recordVersion: string;
  dealerDeploymentOperationType: DealerDeploymentOperationType | null;
  dealerDeploymentId: number | null;
  globalSupplierSupplierId: string | null;
  isSupplierPortal: boolean | null;
  textFilter: string | null;
}

export interface UpdateCynclyLoginTenantAccess {
  baseLoginId: number;
  access: DeploymentAccess;
}

export interface CynclyLoginTenantAccess {
  dateCreated: string;
  id: number;
  recordVersion: string;
  baseLoginId: number;
  access: DeploymentAccess;
}

export interface DealerDeployment {
  dateCreated: string;
  id: number;
  recordVersion: string;
  active: boolean;
  deploymentType: DeploymentType;
  securityAccessToken: string;
  name: string;
  comment: string;
  apiDomain: string;
  otherApiDomains: { [key: string]: string };
  uiDomain: string;
  deploymentLicenceeId: number;
  azureBlobConnectionString: string;
  limitedAccessAzureStorageConnectionString: string;
  azureBlobSASReadToken: string;
  azureBlobSASWriteToken: string;
  azureBlobDomain: string;
  systemType: DealerDeploymentSystemType;
  operationType: DealerDeploymentOperationType;
}

export enum DealerDeploymentOperationType {
  Production = 0,
  Test = 1,
  Development = 2
}

export enum DealerDeploymentSystemType {
  V6 = 0,
  V7 = 1
}

export interface DealerLinkConfig {
  pathBase: string;
  route: string;
  count: number;
}

export interface DeploymentAccess {
  deployments: DeploymentAccessItem[];
}

export interface DeploymentAccessItem {
  deploymentId: number;
  allTenants: boolean;
  tenants: number[];
}

export interface DeploymentAzureConnectionString {
  dealerDeploymentId: number;
  connectionString: string;
}

export interface DeploymentTenantLicensePool {
  dateCreated: string;
  id: number;
  recordVersion: string;
  name: string;
  concurrentUsers: number;
  dateExpires: string;
  dealerDeploymentId: number;
  dealerDeployment: DealerDeployment;
  licenseOwnerType: LicenseOwnerType;
  licenseOwnerName: string;
  licenseOwnerId: number;
}

export enum DeploymentType {
  SingleSupplierOwnerOperator = 0,
  SingleSupplierManaged = 2,
  MultiSupplierManaged = 4,
  SupplierInterface = 8,
  SingleSupplierInterface = 16,
  LicenseServer = 32
}

export interface EmailTemplateApp {
  domain: string[];
}

export interface EmailTemplateDataObject {
  user: EmailTemplateUserFullDetail;
  app: EmailTemplateApp;
  supplier: EmailTemplateSupplier;
  dealer: EmailTemplateDealer;
  quote: EmailTemplateQuote;
  order: EmailTemplateOrder;
  project: EmailTemplateProject;
  error: EmailTemplateError;
}

export interface EmailTemplateDealer {
  name: string;
  brandUrl: string;
}

export interface EmailTemplateEmailLink {
  label: string;
  link: string;
}

export interface EmailTemplateError {
  message: string;
  stack: string;
}

export interface EmailTemplateOrder {
  link: string;
  author: EmailTemplateUserBasicDetail;
  number: string;
  reports: EmailTemplateEmailLink[];
}

export interface EmailTemplateProject {
  link: string;
  number: string;
}

export interface EmailTemplateQuote {
  link: string;
  client: EmailtTemplateQuoteClient;
  author: EmailTemplateUserBasicDetail;
  number: string;
  reports: EmailTemplateEmailLink[];
}

export interface EmailTemplateSupplier {
  name: string;
  brandUrl: string;
  signature: string;
  emailContent: string;
  contact: EmailTemplateUserBasicDetail;
}

export enum EmailTemplateType {
  Production = 0,
  Test = 1
}

export interface EmailTemplateUserBasicDetail {
  friendlyName: string;
  email: string;
  phone: string;
  jobTitle: string;
}

export interface EmailTemplateUserFullDetail {
  friendlyName: string;
  email: string;
  phone: string;
  jobTitle: string;
  userName: string;
  password: string;
}

export interface EmailtTemplateQuoteClient {
  name: string;
  contact: EmailTemplateUserBasicDetail;
}

export interface GlobalSupplier {
  dateCreated: string;
  id: number;
  recordVersion: string;
  name: string;
  displayName: string;
  comments: string;
  notificationsName: string | null;
  notificationsContactName: string;
  notificationsContactJobTitle: string;
  notificationsContactEmail: string;
  notificationsBrandUrl: string;
  automatedEmailFromAddress: string;
  automatedEmailFromName: string;
  supplierId: string;
  parameters: GlobalSupplierParameters;
}

export interface GlobalSupplierParameters {
  items: { [key: string]: string };
}

export interface IEmailServiceTemplate {
  readonly supplierName: string;
  readonly supplierId: string;
  readonly name: string;
  readonly templateUrl: string;
  readonly sendMailAsType: SendMailAsType;
  readonly emailTemplateType: EmailTemplateType;
  readonly sendgridTemplateId: string;
  readonly fromEmailAddress: string;
  readonly fromEmailName: string;
  readonly subject: string;
}

export interface InputAddDealerDeployment {
  deploymentType: DeploymentType;
  name: string;
  comment: string;
  apiDomain: string;
  otherApiDomains: { [key: string]: string };
  uiDomain: string;
  deploymentLicenseeId: number;
  azureBlobConnectionString: string;
  limitedAccessAzureStorageConnectionString: string;
  azureBlobSASReadToken: string;
  azureBlobSASWriteToken: string;
  azureBlobDomain: string;
  extraAllowedLoginHosts: string[];
  supplierInstances: NewSupplierV6Instance[];
  operationType: DealerDeploymentOperationType;
}

export interface InputAddGlobalSupplier {
  supplierId: string | null;
  name: string;
  displayName: string | null;
  comments: string;
  parameters: { [key: string]: string } | null;
  notificationsName: string;
  notificationsContactName: string;
  notificationsContactJobTitle: string;
  notificationsContactEmail: string;
  notificationsBrandUrl: string;
}

export interface InputAddSupplierLogin {
  supplierId: number;
  userName: string;
  friendlyName: string | null;
  emailAddress: string;
  password: string;
  requiresPasswordChange: boolean | null;
  sendNotificationAndPasswordChangeEmail: boolean | null;
  securityRoles: SecurityRoleSelection[];
  claims: { [key: string]: string } | null;
}

export interface InputAddTenant {
  companyName: string;
  onboardedBySupplierId: number | null;
  newLogins: NewTenantLogin[];
  deployments: InputAddTenantToDeployment[];
  claims: { [key: string]: string } | null;
}

export interface InputAddTenantLogin {
  tenantId: number;
  userName: string;
  friendlyName: string | null;
  emailAddress: string;
  phoneNumber: string | null;
  jobTitle: string | null;
  password: string;
  requiresPasswordChange: boolean | null;
  sendNotificationAndPasswordChangeEmail: boolean | null;
  securityRoles: SecurityRoleSelection[];
  claims: { [key: string]: string } | null;
  deploymentClaims: { [key: string]: string } | null;
  active: boolean;
}

export interface InputAddTenantToDeployment {
  tenantId: number | null;
  dbConnectionString: string;
  licensePoolId: number;
  maxLicensePoolAllocation: number;
  details: TenantLicenseConfigurationDetail | null;
  deploymentId: number;
  state: TenantInitializationState;
}

export interface InputAddUser {
  active: boolean;
  securityRoles: SecurityRoleSelection[];
  admin: boolean;
  primaryContact: boolean;
  sendInviteNotification: boolean;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  phoneNumber: string;
  jobTitle: string;
  deploymentClaims: { [key: string]: string };
}

export interface InputById {
  id: number;
}

export interface InputChangeTenantLoginProperties {
  baseLoginId: number;
  active: boolean | null;
  securityRoles: SecurityRoleSelection[] | null;
  admin: boolean | null;
  primaryContact: boolean | null;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
  deploymentClaims: { [key: string]: string } | null;
  sendEmailToUser: boolean | null;
}

export interface InputChangeTenantProperties {
  globalSupplierSupplierId: string;
  tenantId: number;
  dealerDeploymentId: number;
  maxLicensePoolAllocation: number | null;
  primaryContact: BaseLogin | null;
  defaultV6Reference: string | null;
  primaryContactPhoneNumber: string | null;
  primaryContactEmail: string | null;
}

export interface InputConnectSupplierDeploymentToDealer {
  globalSupplierId: number;
  supplierDeploymentId: number;
  dealerDeploymentId: number;
  deleteEntry: boolean;
}

export interface InputEmailTemplates {
  dealerDeploymentId: number;
  suppliers: string[] | null;
}

export interface InputGetEmailTemplate {
  dealerDeploymentId: number;
  supplierId: string;
}

export interface InputGetUserActivityReport {
  dealerDeployments: number[];
}

export interface InputTenantListFilterUpdate {
  filter: CynclyLoginFilter;
}

export interface InputTenantLoginDeploymentConfig {
  dealerDeploymentId: number;
  active: boolean;
}

export interface InputUpdateDealerDeployment {
  dealerDeploymentId: number;
  apiDomain: string | null;
  otherApiDomains: { [key: string]: string } | null;
  uiDomain: string | null;
  azureBlobConnectionString: string | null;
  limitedAccessAzureStorageConnectionString: string | null;
  azureBlobSASReadToken: string | null;
  azureBlobSASWriteToken: string | null;
  azureBlobDomain: string | null;
  newSupplierInstances: NewSupplierV6Instance[];
  removeSupplierInstances: number[];
  name: string | null;
  comment: string | null;
  operationType: DealerDeploymentOperationType | null;
}

export interface InputUpdateGlobalSupplier {
  id: number;
  supplierId: string | null;
  name: string | null;
  displayName: string | null;
  comments: string | null;
  parameters: { [key: string]: string } | null;
  notificationsName: string | null;
  notificationsContactName: string | null;
  notificationsContactJobTitle: string | null;
  notificationsContactEmail: string | null;
  notificationsBrandUrl: string | null;
}

export interface InputUpdateMyUserDetails {
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
  currentPassword: string | null;
  newPassword: string | null;
}

export interface InputUpdateSupplierInstance {
  supplierInstanceId: number;
  description: string | null;
  connection: SupplierInstanceConnectionNullable | null;
  instanceType: string | null;
  maintenanceOwner: MaintenanceOwner | null;
}

export interface InputUpdateSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeploymentId: number;
  referenceOverrides: { [key: string]: string };
}

export interface InputUpdateTenant {
  tenantId: number;
  companyName: string | null;
  newLogins: NewTenantLogin[] | null;
  sendNewLoginEmails: boolean;
  deployments: InputAddTenantToDeployment[] | null;
  securityRoles: SecurityRoleSelection[] | null;
  removeDeployments: number[] | null;
  claims: { [key: string]: string } | null;
}

export interface InputUpdateTenantDealerDeploymentConfig {
  tenantId: number;
  dealerDeploymentId: number;
  dbConnectionString: string | null;
  licensePoolId: number | null;
  maxLicensePoolAllocation: number | null;
  details: TenantLicenseConfigurationDetail | null;
}

export interface InputUpdateTenantLogin {
  tenantId: number;
  userName: string | null;
  friendlyName: string | null;
  emailAddress: string | null;
  phoneNumber: string | null;
  jobTitle: string | null;
  deployments: number[] | null;
  securityRoles: SecurityRoleSelection[] | null;
  tenantLoginId: number | null;
  deleteDeployments: number[] | null;
  deleteSecurityRoles: SecurityRoleSelection[] | null;
  configuration: InputTenantLoginDeploymentConfig[] | null;
  claims: { [key: string]: string } | null;
}

export interface InputV2TenantLoginDeploymentConfig {
  id: number;
  tenantLoginId: number;
  dealerDeploymentId: number;
  active: boolean;
}

export interface Int32StringKeyValuePair {
  key: number;
  value: string | null;
}

export enum LicenseOwnerType {
  Internal = 0,
  Tenant = 1,
  Supplier = 2,
  Managed = 4
}

export interface LoginPasswordChangeRequired {
  token: string;
}

export interface LoginPublicInfoPrivate {
  id: string;
  tenantId: number;
  tenantName: string;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  phone: string;
  jobTitle: string;
  tokenDateExpires: string;
}

export interface LoginSecurityRole {
  dateCreated: string;
  id: number;
  recordVersion: string;
  roleType: LoginSecurityRoleType;
  name: string;
  description: string;
  permissions: LoginSecurityRolePermissions;
}

export interface LoginSecurityRolePermissions {
  items: SecurityRolePermission[];
}

export enum LoginSecurityRoleType {
  All = 0,
  Dealers = 1,
  Suppliers = 2
}

export enum MaintenanceOwner {
  Licensor = 1,
  Licensee = 2
}

export interface NewSupplierV6Instance {
  globalSupplierId: number;
  description: string;
  connection: SupplierInstanceConnection;
  isSupplierOffice: boolean | null;
  maintenanceOwner: MaintenanceOwner;
}

export interface NewTenantLogin {
  userName: string;
  friendlyName: string;
  emailAddress: string;
  password: string;
  jobTitle: string | null;
  phoneNumber: string;
  mustChangePassword: boolean;
  securityRoles: SecurityRoleSelection[];
  claims: { [key: string]: string } | null;
}

export enum Permission {
  None = 0,
  View = 1,
  Edit = 2,
  Add = 4,
  Delete = 8,
  Setup = 16,
  Browse = 32
}

export interface RequestAllTenantLoginsClaims {
  tenantId: number;
  dealerDeploymentId: number;
}

export interface RequestAllTenantLoginsPublicInfo {
  tenantId: number;
  dealerDeploymentId: number | null;
}

export interface RequestAttachTenantLoginToDeployment {
  dealerDeploymentId: number;
  tenantLoginId: number;
  securityRoles: SecurityRoleSelection[];
}

export interface RequestByDealerDeploymentId {
  dealerDeploymentId: number;
}

export interface RequestByTenantId {
  tenantId: number;
}

export interface RequestDbConnections {
  dealerDeploymentId: number;
}

export interface RequestDealerDeployment {
  dealerDeploymentId: number;
}

export interface RequestGetAzureConnectionInfo {
  keys: SupplierInstanceAccessKey[];
}

export interface RequestGetBackgroundApiToken {
  dealerDeploymentId: number;
  tenantId: number;
}

export interface RequestGetSecurityRoles {}

export interface RequestGetSupplierPrimaryContact {
  supplierId: string;
  dealerDeploymentId: number;
}

export interface RequestGetSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeploymentId: number;
}

export interface RequestGetTenantPrimaryContact {
  tenantId: number;
  dealerDeploymentId: number;
}

export interface RequestNotify {
  dealerDeploymentId: number;
  command: string;
  information: { [key: string]: string };
}

export interface RequestObjectById {
  id: number;
}

export interface RequestOnBoardTenant {
  companyName: string;
  businessPhone: string | null;
  reference: string;
  licensePoolId: number;
  licenseAllocation: number;
  deploymentId: number;
  initialUserName: string;
  initialUserEmail: string;
  initialName: string;
  initialPhone: string;
  initialJobTitle: string | null;
}

export interface RequestPAT {
  dealerDeploymentId: number;
  tenantId: number;
  preferredLifeOfTokenHours: number | null;
  claims: { [key: string]: string };
}

export interface RequestSupplierApiAccess {
  dealerDeploymentId: number;
  id: number | null;
  supplierId: string | null;
}

export interface RequestSupplierLogin {
  dealerDeploymentId: number | null;
  userName: string;
  password: string;
  code2FA: string | null;
}

export interface RequestSystemLogin {
  userName: string;
  password: string;
}

export interface RequestSystemTokenVerification {
  token: string;
}

export interface RequestTenantInfo {
  dealerDeploymentId: number;
  tenantId: number;
}

export interface RequestTenantLicenseInformation {}

export interface RequestTenantList {}

export interface RequestTenantListFilter {}

export interface RequestTenantLogin {
  userName: string;
  password: string;
  code2FA: string | null;
  dealerDeploymentId: number;
}

export interface RequestTenantLoginPasswordReset {
  userName: string;
}

export interface RequestTenantLoginWithPasswordChange {
  userName: string;
  password: string;
  code2FA: string | null;
  dealerDeploymentId: number;
  token: string;
}

export interface RequestTenantLogins {}

export interface RequestTokenVerification {
  dealerDeploymentId: number;
  token: string;
}

export interface RequestUserInfo {
  dealerDeploymentId: number;
  tenantId: number;
  userId: string[];
}

export interface RequestV6Notify {
  keys: SupplierInstanceAccessKey[];
  command: string;
  information: { [key: string]: string };
}

export interface ResultAddDealerDeployment {
  dealerDeployment: DealerDeployment | null;
  issues: string[];
}

export interface ResultAddSupplierLogin {
  supplierLogin: SupplierLogin | null;
  issues: string[];
}

export interface ResultAddTenantLogin {
  tenantLogin: TenantLogin | null;
  issues: string[];
}

export interface ResultAllTenantLoginsClaims {
  loginClaims: ResultUserClaims[];
}

export interface ResultAllTenantLoginsPublicInfo {
  logins: TenantLoginPublicInfo[];
}

export interface ResultApiDetails {
  licenseServerHost: string;
  apiDomain: string;
  uiDomain: string;
  otherApiDomains: { [key: string]: string };
  dealerDeploymentId: number;
  buildNumber: string;
  buildNumberAsInt: number;
}

export interface ResultBackgroundApiToken {
  dealerDeploymentId: number;
  tenantId: number;
  apiToken: string;
}

export interface ResultBrandInfo {
  loginImageUrl: string;
  loginBrandLogo: string;
  footerBrandLogo: string;
  operationType: DealerDeploymentOperationType;
}

export interface ResultChangeTenantProperties {
  tenant: Tenant;
  tenantDealerDeploymentConfig: TenantDealerDeploymentConfig;
  primaryContact: BaseLogin;
}

export interface ResultCheckUserName {
  exists: boolean;
}

export interface ResultConnectSupplierDeploymentToDealer {
  globalSupplierId: number;
  supplierDeploymentId: number;
  dealerDeploymentId: number;
}

export interface ResultCynclySupportTenantList {
  tenants: TenantAccessInfo[];
}

export interface ResultCynclySupportTenantListFilter {
  loginFilter: CynclyLoginFilter;
}

export interface ResultDbConnection {
  connectionString: string;
}

export interface ResultDbConnections {
  connectionStrings: Int32StringKeyValuePair[];
}

export interface ResultDealerDeploymentConfiguration {
  config: ViewDealerDeploymentConfiguration;
}

export interface ResultEmailTemplates {
  templates: IEmailServiceTemplate[];
}

export interface ResultFullSupplierNetwork {
  globalSuppliers: GlobalSupplier[];
  dealerDeployments: DealerDeployment[];
  supplierInstances: SupplierInstance[];
  tenantDealerDeploymentConfigs: TenantDealerDeploymentConfig[];
  deploymentTenantLicensePools: DeploymentTenantLicensePool[];
  supplierInstanceInformation: { [key: string]: { [key: string]: string } };
  deploymentInformation: { [key: string]: { [key: string]: string } };
  tenants: Tenant[];
  cynclyLoginTenantAccesses: CynclyLoginTenantAccess[];
}

export interface ResultGetSupplierReferenceCodeOnTenant {
  tenantId: number;
  dealerDeplymentId: number;
  referenceOverrides: { [key: string]: string };
}

export interface ResultGetTenantDeploymentLicenseInfo {
  suppliers: ViewGlobalSupplierDetailEx[];
  licensePool: SystemViewLicensePool | null;
  tenant: Tenant;
  licensePoolAllocations: number;
  licensePoolAllocated: number;
}

export interface ResultGetTenantPrimaryContact {
  info: TenantLoginPublicInfo;
}

export interface ResultGetUserActivityReport {
  items: ViewUserActivityReportItem[];
}

export interface ResultLogin {
  passwordChangeRequired: LoginPasswordChangeRequired | null;
  requires2FA: boolean;
  token2FA: string | null;
  authenticationToken: string;
  publicInfo: LoginPublicInfoPrivate;
}

export interface ResultNotify {}

export interface ResultOnBoardTenant {
  tenantId: number;
  state: TenantInitializationState;
}

export interface ResultPAT {
  pat: string;
}

export interface ResultSecurityRoles {
  roles: LoginSecurityRole[];
}

export interface ResultSupplierApiAccess {
  servers: SupplierApiAccess[];
}

export interface ResultSupplierApiTokenAccess {
  servers: SupplierApiTokenAccess[];
}

export interface ResultSupplierInstances {
  instances: ViewSupplierInstance[];
}

export interface ResultSupplierLogin {
  passwordChangeRequired: SupplierLoginPasswordChangeRequired | null;
  requires2FA: boolean;
  token2FA: string | null;
  authenticationToken: string;
  publicInfo: SupplierLoginPublicInfoPrivate;
}

export interface ResultSystemLogin {
  passwordChangeRequired: SystemLoginPasswordChangeRequired | null;
  authenticationToken: string;
  publicInfo: SystemLoginPublicInfoPrivate;
}

export interface ResultTenantLicenseInformation {
  maxLicenseAllocations: number;
  licensesUsed: number;
}

export interface ResultTenantList {
  deployments: ViewDeploymentTenants[];
  tenants: Tenant[];
  globalSupplierSupplierId: string;
  globalSupplierId: number;
}

export interface ResultTenantLoginPasswordReset {
  userName: string;
  oneTimePassword: string;
}

export interface ResultTenantLoginsView {
  logins: ViewBaseLogin[];
}

export interface ResultUpdateDealerDeployment {
  config: ViewDealerDeploymentConfiguration;
  issues: string[];
}

export interface ResultUpdateSupplierReferenceCodeOnTenant {}

export interface ResultUpdateTenant {
  config: ViewTenantDeploymentConfiguration;
  issues: string[];
}

export interface ResultUserClaims {
  systemUserId: string;
  claims: { [key: string]: string };
}

export interface ResultUserPublicInfo {
  userInfo: TenantLoginPublicInfo[];
}

export interface ResultValid {
  isValid: boolean;
}

export interface ResultVerifyUser {
  claims: { [key: string]: string };
}

export interface SecurityRolePermission {
  serviceId: number;
  section: number;
  permissions: number;
}

export interface SecurityRoleSelection {
  id: number | null;
  name: string | null;
}

export enum SendMailAsType {
  Default = 0,
  Supplier = 1
}

export interface Service {
  id: number;
  permissions: { [key: string]: Permission };
}

export interface Services {
  serviceList: { [key: string]: Service };
}

export interface SupplierApiAccess {
  host: string;
  serverToServerToken: string;
  tenantId: number;
  globalSupplierId: number;
  dealerDeploymentId: number;
}

export interface SupplierApiTokenAccess {
  host: string;
  apiToken: string;
  globalSupplierId: number;
}

export interface SupplierInstance {
  dateCreated: string;
  id: number;
  recordVersion: string;
  description: string;
  connection: SupplierInstanceConnection;
  maintenanceOwner: MaintenanceOwner;
  instanceType: SupplierInstanceType;
  globalSupplierId: number;
  dealerDeploymentId: number;
  eventAccessKey: string;
}

export interface SupplierInstanceAccessKey {
  supplierInstanceId: number;
  accessKey: string;
}

export interface SupplierInstanceAuthentication {
  scheme: V6LinkAuthenticationMethod;
  apiKey: string;
  certificate: string;
}

export interface SupplierInstanceConnection {
  authentication: SupplierInstanceAuthentication;
  endpoints: string[];
  dealerLink: DealerLinkConfig | null;
}

export interface SupplierInstanceConnectionNullable {
  authentication: SupplierInstanceAuthentication | null;
  endpoints: string[] | null;
  dealerLink: DealerLinkConfig | null;
}

export enum SupplierInstanceType {
  DealerConfigurator = 1,
  SupplierOffice = 2,
  BackOffice = 4
}

export interface SupplierLogin {
  dateCreated: string;
  id: number;
  recordVersion: string;
  baseLoginId: number;
  baseLogin: BaseLogin;
  supplierId: number;
}

export interface SupplierLoginPasswordChangeRequired {
  token: string;
}

export interface SupplierLoginPublicInfoPrivate {
  id: string;
  tenantId: number;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  tokenDateExpires: string;
}

export interface SupplierReference {
  supplierId: number;
  reference: string;
  preferredSupplierOfficeInstanceId: number | null;
  allowSupplierSupportAccess: boolean;
  referenceOverrides: { [key: string]: string } | null;
}

export interface SupplierTenantInfo {
  tenantId: number;
  allowSupplierSupportAccess: boolean;
  reference: string;
  licensePoolAllocations: number;
  licensePoolAllocated: number;
  state: TenantInitializationState;
  primaryContact: BaseLogin | null;
}

export interface SystemLoginPasswordChangeRequired {
  token: string;
}

export interface SystemLoginPublicInfoPrivate {
  systemId: number;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  tokenDateExpires: string;
}

export interface SystemViewDeployment {
  dealerDeployment: DealerDeployment;
  tenant: Tenant[];
  tenantDealerDeploymentConfig: TenantDealerDeploymentConfig[];
  tenantLogin: TenantLogin[];
  tenantLoginDeploymentConfig: TenantLoginDeploymentConfig[];
  globalSupplier: GlobalSupplier[];
  supplierInstance: SupplierInstance[];
  licensePool: DeploymentTenantLicensePool[];
}

export interface SystemViewLicensePool {
  licensePool: DeploymentTenantLicensePool;
  availableUsers: number;
  availableAllocations: number;
}

export interface SystemViewTenant {
  tenant: Tenant;
  tenantDealerDeploymentConfig: TenantDealerDeploymentConfig[];
  tenantLogin: TenantLogin[];
  tenantLoginDeploymentConfig: TenantLoginDeploymentConfig[];
  globalSupplier: GlobalSupplier[];
  licensePool: DeploymentTenantLicensePool[];
}

export interface Tenant {
  dateCreated: string;
  id: number;
  recordVersion: string;
  companyName: string;
  primaryContact: string;
  primaryContactPhoneNumber: string;
  primaryContactEmail: string;
  claims: { [key: string]: string };
  physicalAddress: Address;
  onboardedBySupplierId: number | null;
}

export interface TenantAccessInfo {
  tenantId: number;
  companyName: string;
  deploymentName: string;
  uiDomain: string;
  dealerDeploymentId: number;
  suppliers: ViewGlobalSupplierDetail[];
  isSupplierPortal: boolean;
  operationType: DealerDeploymentOperationType;
}

export interface TenantDealerDeploymentConfig {
  dateCreated: string;
  id: number;
  recordVersion: string;
  dbConnectionString: string;
  tenantId: number;
  dealerDeploymentId: number;
  deploymentTenantLicensePoolId: number | null;
  maxLicensePoolAllocation: number;
  details: TenantLicenseConfigurationDetail;
  state: TenantInitializationState;
}

export enum TenantInitializationState {
  Available = 0,
  RequestedBySupplier = 1,
  PendingDelivery = 2,
  Disabled = 4
}

export interface TenantLicenseConfigurationDetail {
  supplierReferences: SupplierReference[];
}

export interface TenantLogin {
  dateCreated: string;
  id: number;
  recordVersion: string;
  baseLoginId: number;
  baseLogin: BaseLogin;
  tenantId: number;
}

export interface TenantLoginDeploymentConfig {
  dateCreated: string;
  id: number;
  recordVersion: string;
  tenantLoginId: number;
  dealerDeploymentId: number;
  active: boolean;
  claims: { [key: string]: string };
  lastLoginTime: string | null;
}

export interface TenantLoginPublicInfo {
  id: string;
  tenantId: number;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  jobTitle: string;
  phone: string;
}

export enum TokenOrigin {
  None = 0,
  LicenseServer = 1,
  Deployment = 2,
  PAT = 4,
  DealerConnect = 8
}

export interface UnauthorizedResult {
  statusCode: number;
}

export enum UserType {
  None = 0,
  TenantLogin = 1,
  TenantAdmin = 2,
  DeploymentAdministrator = 4,
  LicenseServerLogin = 8,
  SupplierLogin = 16,
  SupplierAdmin = 32
}

export enum V6LinkAuthenticationMethod {
  None = 0,
  ApiKey = 1,
  ClientCertificate = 2
}

export interface ViewBaseLogin {
  tenantId: number;
  baseLogin: BaseLogin;
  roles: string[];
  deploymentClaims: { [key: string]: string };
  active: boolean;
  lastLoginTime: string | null;
  allClaims: { [key: string]: string } | null;
}

export interface ViewDealerDeploymentConfiguration {
  dealerDeploymentId: number;
  deploymentType: DeploymentType;
  operationType: DealerDeploymentOperationType;
  tenantConfiguration: ViewTenantConfig[];
  apiDomain: string;
  otherApiDomains: { [key: string]: string };
  uiDomain: string;
  azureBlobConnectionString: string;
  publicAssetRootPath: string;
  limitedAccessAzureStorageConnectionString: string;
  azureBlobSASReadToken: string;
  azureBlobSASWriteToken: string;
  azureBlobDomain: string;
  suppliers: ViewGlobalSupplier[];
}

export interface ViewDeploymentBasicInfo {
  id: number;
  name: string;
  apiDomain: string;
  otherApiDomains: { [key: string]: string };
  uiDomain: string;
  suppliers: ViewGlobalSupplier[];
}

export interface ViewDeploymentTenants {
  dealerDeploymentId: number;
  name: string;
  uiDomain: string;
  tenants: SupplierTenantInfo[];
  userLoginInformation: ViewUserLoginInformation[];
  licensePools: SystemViewLicensePool[];
}

export interface ViewGlobalSupplier {
  id: number;
  name: string;
  supplierId: string;
  supplierInstances: ViewSupplierInstance[];
  parameters: { [key: string]: string };
  displayName: string;
  automatedEmailFromAddress: string;
  automatedEmailFromName: string;
  azureBlobDomain: string;
  azureBlobSASReadToken: string;
}

export interface ViewGlobalSupplierDetail {
  id: number;
  supplierId: string;
  name: string;
  displayName: string;
}

export interface ViewGlobalSupplierDetailEx {
  id: number;
  supplierId: string;
  name: string;
  displayName: string;
  azureBlobDomain: string;
  azureBlobSASReadToken: string;
}

export interface ViewSupplierInstance {
  id: number;
  description: string;
  instanceType: SupplierInstanceType;
  connection: SupplierInstanceConnection;
  outageEmail: string;
}

export interface ViewTenantConfig {
  tenantId: number;
  companyName: string;
  primaryContact: string;
  primaryContactPhoneNumber: string;
  primaryContactEmail: string;
  dbConnectionString: string;
  dateExpires: string;
  details: TenantLicenseConfigurationDetail;
  allowedSuppliers: string[];
}

export interface ViewTenantConfigDeployment {
  deployment: ViewDeploymentBasicInfo;
  configuration: ViewTenantConfig;
}

export interface ViewTenantDeploymentConfiguration {
  tenantId: number;
  tenantConfiguration: ViewTenantConfigDeployment[];
}

export interface ViewUserActivityReportItem {
  systemUserId: string;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  phoneNumber: string;
  lastLoginDateTime: string | null;
  active: string;
  tenantId: number;
  tenantName: string;
  primaryContact: string;
  primaryContactEmail: string;
  primaryContactPhoneNumber: string;
  isSupplier: number;
  deploymentId: number;
  deploymentName: string;
}

export interface ViewUserLoginInformation {
  tenantId: number;
  tenantLoginId: number;
  userName: string;
  friendlyName: string;
  emailAddress: string;
  active: boolean;
  lastLoginTime: string | null;
  claims: { [key: string]: string };
  systemUserId: string;
}
